import type { UseFormMethods } from "react-hook-form";
import { ICustomerDetailsForm } from "@features/customerDetails/ICustomerDetailsForm";
import { Address } from "@features/address/Address";
import { useStyle } from "@features/customerDetails/style";

interface IParams {
    formMethods: UseFormMethods<ICustomerDetailsForm>;
}

export const CustomerDetailsDeliveryAddress = (props: IParams) => {
    const { formMethods } = props;
    const { classes } = useStyle();

    return (
        <div className={classes.deliveryAddressWrapper}>
            <Address addressForm={formMethods} prefix="deliveryAddress" />
        </div>
    );
};
